import { useMsal } from "@azure/msal-react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup, {
 toggleButtonGroupClasses,
} from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {BASE_API_URL as baseURL} from "../../Constant"
// const baseURL = "http://localhost:3014";
// const baseURL = "https://atcgn.lkm.accenture.com/atcgn-api";

const SubmitButton = styled(Button)(({ theme }) => ({
 backgroundColor: "#460073",
 color: "white",
 border: "solid 1px grey",
 textTransform: "none",
 padding: "6px 10px",
 fontSize: "14px",
 fontWeight: "500",
 "&:hover": { backgroundColor: "#460073", color: "white" },
 "&:active": {
  backgroundColor: "#460073",
  color: "white",
 },
}));
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
 [`& .${toggleButtonGroupClasses.grouped}`]: {
  margin: theme.spacing(0.5),
  border: 0,
  borderRadius: theme.shape.borderRadius,
  [`&.${toggleButtonGroupClasses.disabled}`]: {
   border: 0,
  },
  backgroundColor: "white",
 },
 [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
  {
   marginLeft: -1,
   borderLeft: "1px solid transparent",
  },
}));

function FeedbackContent() {
 const countArr = [1, 2, 3, 4, 5];
 const [isSubmitted, setIsSubmitted] = useState(false);
 const [content, setContent] = useState("");

 const [username, setUsername] = React.useState();
 const [count, setCount] = useState(0);

 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 useEffect(() => {
  if (activeAccount) setUsername(activeAccount.idTokenClaims.enterpriseID);
 }, [activeAccount]);

 const handleSubmit = () => {
  setIsSubmitted(true);

  let data = { username: username, rate: selectedRate, content: content };
  axios
   .post(
    `${baseURL}/submitfeedback`,
    { data },
    {
     headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "application/json",
     },
    }
   )
   .then((res) => {
    console.log("success", res.data);
   })
   .catch((err) => {
    console.error("failed to fetch");
   });
 };

 const [selectedRate, setSelectedRate] = useState([]);

 const handleCountUpdate = (event, newFormats) => {
  console.log(newFormats);
  setSelectedRate(newFormats);
 };

 return (
  <Box
   sx={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    "& > :not(style)": {
     m: 1,
     width: 800,
     borderRadius: "10px",
     marginTop: "30px",
    },
   }}
  >
   <Paper elevation={3}>
    <Stack sx={{ padding: "20px" }} spacing={2}>
     <Typography sx={{ fontSize: "20px", color: "#460073", fontWeight: "600" }}>
      Rate your experience with our website...
     </Typography>
     <Stack direction={"row"} spacing={2} alignItems={"center"}>
      <StyledToggleButtonGroup
       value={selectedRate}
       onChange={handleCountUpdate}
       aria-label="text formatting"
      >
       {countArr.map((val) => (
        <ToggleButton value={val} aria-label="italic">
         {selectedRate.includes(val) ? (
          <StarIcon sx={{ color: "#008000" }} />
         ) : (
          <StarBorderIcon />
         )}
        </ToggleButton>
       ))}
      </StyledToggleButtonGroup>
      {selectedRate.length !== 0 && (
       <Stack direction={"row"} spacing={1}>
        <Typography sx={{ color: "#460073", fontWeight: "600", fontSize: "18px" }}>
         {selectedRate.length}
        </Typography>

        <Typography sx={{ color: "#460073", fontWeight: "600", fontSize: "18px" }}>
         {" "}
         {selectedRate.length == 1 ? "star" : "stars"}
        </Typography>
       </Stack>
      )}
     </Stack>
    </Stack>
   </Paper>

   <Paper elevation={3}>
    <Stack sx={{ padding: "20px" }} spacing={2}>
     <Typography sx={{ fontSize: "20px", color: "#460073", fontWeight: "600" }}>
      Anything that can be improved?
     </Typography>
     <TextField
      id="outlined-multiline-static"
      multiline
      rows={4}
      placeholder="Your Feedback(Optional)"
      onChange={(event) => {
       setContent(event.target.value);
      }}
     />
     <SubmitButton
      sx={{ width: "100px" }}
      onClick={() => {
       handleSubmit();
      }}
     >
      Submit
     </SubmitButton>
    </Stack>
   </Paper>
   {isSubmitted && (
    <Paper elevation={3}>
     <Stack sx={{ padding: "20px" }} spacing={2} direction={"row"}>
      <CheckCircleIcon sx={{ color: "green" }} />
      <Typography sx={{ fontSize: "18px" }}>Thanks for the feedback! </Typography>
     </Stack>
    </Paper>
   )}
  </Box>
 );
}

export default FeedbackContent;
